const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.118478,0,0,0.118478,0.102602,16.3749)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.866,
    y: -1.386,
    width: 506.425,
    height: 232.775,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.8,324.4L210.4,180.4L250.4,180.4L225.6,324.4L184.8,324.4Z",
    style: {
      fill: "rgb(60,88,191)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.8,324.4L217.6,180.4L250.4,180.4L225.6,324.4L184.8,324.4Z",
    style: {
      fill: "rgb(41,54,136)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.4,182C362.4,178.8 349.6,175.6 333.6,175.6C293.6,175.6 264.8,195.6 264.8,224.4C264.8,246 284.8,257.2 300.8,264.4C316.8,271.6 321.6,276.4 321.6,282.8C321.6,292.4 308.8,297.2 297.6,297.2C281.6,297.2 272.8,294.8 259.2,289.2L253.6,286.8L248,319.6C257.6,323.6 275.2,327.6 293.6,327.6C336,327.6 364,307.6 364,277.2C364,260.4 353.6,247.6 329.6,237.2C315.2,230 306.4,226 306.4,218.8C306.4,212.4 313.6,206 329.6,206C343.2,206 352.8,208.4 360,211.6L364,213.2L370.4,182Z",
    style: {
      fill: "rgb(60,88,191)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.4,182C362.4,178.8 349.6,175.6 333.6,175.6C293.6,175.6 272,195.6 272,224.4C272,246 284.8,257.2 300.8,264.4C316.8,271.6 321.6,276.4 321.6,282.8C321.6,292.4 308.8,297.2 297.6,297.2C281.6,297.2 272.8,294.8 259.2,289.2L253.6,286.8L248,319.6C257.6,323.6 275.2,327.6 293.6,327.6C336,327.6 364,307.6 364,277.2C364,260.4 353.6,247.6 329.6,237.2C315.2,230 306.4,226 306.4,218.8C306.4,212.4 313.6,206 329.6,206C343.2,206 352.8,208.4 360,211.6L364,213.2L370.4,182Z",
    style: {
      fill: "rgb(41,54,136)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.2,180.4C429.6,180.4 422.4,181.2 418.4,190.8L358.4,324.4L401.6,324.4L409.6,300.4L460.8,300.4L465.6,324.4L504,324.4L470.4,180.4L439.2,180.4ZM420.8,276.4C423.2,269.2 436.8,234 436.8,234C436.8,234 440,225.2 442.4,219.6L444.8,233.2C444.8,233.2 452.8,269.2 454.4,277.2L420.8,277.2L420.8,276.4Z",
    style: {
      fill: "rgb(60,88,191)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.8,180.4C439.2,180.4 432,181.2 428,190.8L358.4,324.4L401.6,324.4L409.6,300.4L460.8,300.4L465.6,324.4L504,324.4L470.4,180.4L448.8,180.4ZM420.8,276.4C424,268.4 436.8,234 436.8,234C436.8,234 440,225.2 442.4,219.6L444.8,233.2C444.8,233.2 452.8,269.2 454.4,277.2L420.8,277.2L420.8,276.4Z",
    style: {
      fill: "rgb(41,54,136)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.2,281.2L107.2,260.4C100,236.4 76.8,210 51.2,197.2L87.2,325.2L130.4,325.2L195.2,181.2L152,181.2L111.2,281.2Z",
    style: {
      fill: "rgb(60,88,191)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.2,281.2L107.2,260.4C100,236.4 76.8,210 51.2,197.2L87.2,325.2L130.4,325.2L195.2,181.2L160,181.2L111.2,281.2Z",
    style: {
      fill: "rgb(41,54,136)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,180.4L7.2,182C58.4,194 93.6,224.4 107.2,260.4L92.8,192.4C90.4,182.8 83.2,180.4 74.4,180.4L0,180.4Z",
    style: {
      fill: "rgb(255,188,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,180.4C51.2,192.4 93.6,223.6 107.2,259.6L93.6,202.8C91.2,193.2 83.2,187.6 74.4,187.6L0,180.4Z",
    style: {
      fill: "rgb(247,152,29)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,-139.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,180.4C51.2,192.4 93.6,223.6 107.2,259.6L97.6,228.4C95.2,218.8 92,209.2 80.8,205.2L0,180.4Z",
    style: {
      fill: "rgb(237,124,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.134021,0.614434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.2,276.4L124,249.2L111.2,279.6L108,259.6C100.8,235.6 77.6,209.2 52,196.4L88,324.4L131.2,324.4L151.2,276.4Z",
    style: {
      fill: "rgb(5,18,68)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.6,324.4L191.2,289.2L184.8,324.4L225.6,324.4Z",
    style: {
      fill: "rgb(5,18,68)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.6,274.8C320.8,278 322.4,280.4 321.6,283.6C321.6,293.2 308.8,298 297.6,298C281.6,298 272.8,295.6 259.2,290L253.6,287.6L248,320.4C257.6,324.4 275.2,328.4 293.6,328.4C319.2,328.4 340,321.2 352,308.4L317.6,274.8Z",
    style: {
      fill: "rgb(5,18,68)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,324.4L401.6,324.4L409.6,300.4L460.8,300.4L465.6,324.4L504,324.4L490.4,266L442.4,219.6L444.8,232.4C444.8,232.4 452.8,268.4 454.4,276.4L420.8,276.4C424,268.4 436.8,234 436.8,234C436.8,234 440,225.2 442.4,219.6",
    style: {
      fill: "rgb(5,18,68)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4e1eacd4a84019969c2d82753014262e.svg";
export { ForwardRef as ReactComponent };